module.exports = __webpack_public_path__ + "static/media/forgot-password-email-sent.bfaae0ba.png";